module.exports = __webpack_public_path__ + "img/syukyaku-top-023.40d52a63.jpg";